import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper w-ful" }
const _hoisted_3 = {
  class: "modal-container w-full col gap-08",
  ref: "target"
}
const _hoisted_4 = { class: "w-full mtop-10" }
const _hoisted_5 = { class: "modal-body w-full" }
const _hoisted_6 = { class: "row w-full" }
const _hoisted_7 = { class: "col-0-6 colend mright-04" }
const _hoisted_8 = { class: "main-m font-m" }

import { watch, ref, computed } from "vue";
import { PersonLightResponse } from '@/apiGenerate/medserver';
import { useI18n } from "vue-i18n";
import Select from 'primevue/select';
import { useAppUserStore } from "@/stores/appUser";
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esSelectHealthProDelegateModal',
  props: {
    isOpen: { type: Boolean },
    healthProDelegate: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const appUserStore = useAppUserStore();

const selectedHealthProDelegate = ref<PersonLightResponse>(undefined);

const emits = __emit;

const currentPerson = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr
});

const confirmFormModal = () => {
  emits('modal-close', selectedHealthProDelegate.value);
};

const closeFormModal = () => {
    emits('modal-close');
}

watch(
    () => props.isOpen,
   () => {
    if (props.isOpen) {
      selectedHealthProDelegate.value = props.healthProDelegate[0];
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_es_modal_header, {
                header: _unref(t)('patient.delegate.title')
              }, null, 8, ["header"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)('patient.delegate.label')), 1)
                ]),
                _createVNode(_unref(Select), {
                  modelValue: selectedHealthProDelegate.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedHealthProDelegate).value = $event)),
                  options: _ctx.healthProDelegate,
                  size: "small",
                  class: "w-full"
                }, _createSlots({
                  option: _withCtx((slotProps) => [
                    _createElementVNode("span", {
                      class: _normalizeClass({'font-bold-700': slotProps.option.id === currentPerson.value.id})
                    }, _toDisplayString(_unref(PersonService).formatName(slotProps.option.lastname, slotProps.option.firstname)), 3)
                  ]),
                  _: 2
                }, [
                  (selectedHealthProDelegate.value)
                    ? {
                        name: "value",
                        fn: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(_unref(PersonService).formatName(slotProps.value.lastname, slotProps.value.firstname)), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ])
            ]),
            _createVNode(_component_es_modal_footer, {
              onModalCancel: closeFormModal,
              confirmLabel: 'action.confirm',
              confirmModalMethod: async () => await confirmFormModal()
            }, null, 8, ["confirmModalMethod"])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})